<!-- SAN-1479: one-time DPDP consent prompt for new users -->
<ng-container *ngIf="visible">
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="consentPromptTitle">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title fw-bold" id="consentPromptTitle">How would you like to hear from us?</h3>
        </div>
        <div class="modal-body">
          <p class="text-muted fs-6">
            We only send what you agree to. You can change this at any time in your account settings.
          </p>
          <label class="form-check form-check-custom form-check-solid align-items-start mb-5">
            <input class="form-check-input mt-1" type="checkbox" [(ngModel)]="emailUpdates" name="consentEmailUpdates">
            <span class="form-check-label">
              <span class="fw-semibold d-block">Email me promotions and summaries</span>
              <span class="text-muted fs-7">New opportunities, events, programs, offers and periodic round-ups.</span>
            </span>
          </label>
          <label class="form-check form-check-custom form-check-solid align-items-start mb-5">
            <input class="form-check-input mt-1" type="checkbox" [(ngModel)]="whatsappUpdates" name="consentWhatsappUpdates">
            <span class="form-check-label">
              <span class="fw-semibold d-block">Send me WhatsApp messages</span>
              <span class="text-muted fs-7">Chat alerts, activity updates and promotions on WhatsApp.</span>
            </span>
          </label>
          <p class="text-muted fs-7 mb-0">
            Emails about activity on your account (such as connection requests and meetings), and security messages such as one-time passwords, are still sent.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" (click)="later()">Decide later</button>
          <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">Save my choices</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</ng-container>
